export default __webpack_public_path__ + "static/media/snowman.184b1982.webp";